"use client";
import * as React from 'react';

import { cn } from '../../utils/ui';

const baseClassName = [
  'dark:bg-input/30',
  'border-input',
  'focus-visible:border-ring',
  'focus-visible:ring-ring/50',
  'aria-invalid:ring-destructive/20',
  'dark:aria-invalid:ring-destructive/40',
  'aria-invalid:border-destructive',
  'dark:aria-invalid:border-destructive/50',
  'disabled:bg-input/50',
  'dark:disabled:bg-input/80',
  'h-8',
  'rounded-sm',
  'border',
  'bg-transparent',
  'px-2.5',
  'py-1',
  'text-base',
  'transition-colors',
  'file:h-6',
  'file:text-sm',
  'file:font-medium',
  'focus-visible:ring-3',
  'aria-invalid:ring-3',
  'md:text-sm',
  'w-full',
  'min-w-0',
  'outline-none',
  'file:inline-flex',
  'file:border-0',
  'file:bg-transparent',
  'file:text-foreground',
  'placeholder:text-muted-foreground',
  'disabled:pointer-events-none',
  'disabled:cursor-not-allowed',
  'disabled:opacity-50',
].join(' ');

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return <input type={type} data-slot="input" className={cn(baseClassName, className)} ref={ref} {...props} />;
  },
);

export { Input };
